import React , {useState,useEffect} from 'react'
import { useSelector , useDispatch } from 'react-redux'
import DefaultLayout from '../components/DefaultLayout'
import { getAllCars } from '../redux/actions/carsActions'
import { Col, Row , Divider , DatePicker, Checkbox, Input, Slider} from 'antd'
import { SearchOutlined, CarOutlined, ThunderboltOutlined, FireOutlined } from '@ant-design/icons'
import {Link} from 'react-router-dom'
import Spinner from '../components/Spinner';
import moment from 'moment'
const {RangePicker} = DatePicker

const categories = [
    { key: 'All', label: 'All', icon: <CarOutlined /> },
    { key: 'Petrol', label: 'Petrol', icon: <FireOutlined /> },
    { key: 'Diesel', label: 'Diesel', icon: <ThunderboltOutlined /> },
    { key: 'Electric', label: 'Electric', icon: <ThunderboltOutlined /> },
    { key: 'CNG', label: 'CNG', icon: <FireOutlined /> },
]

function Home() {
    const {cars} = useSelector(state=>state.carsReducer)
    const {loading} = useSelector(state=>state.alertsReducer)
    const [totalCars , setTotalcars] = useState([])
    const [searchTerm , setSearchTerm] = useState('')
    const [activeCategory, setActiveCategory] = useState('All')
    const [maxPrice, setMaxPrice] = useState(5000)
    const [priceRange, setPriceRange] = useState([0, 5000])
    const dispatch = useDispatch()
    

    useEffect(() => {
        dispatch(getAllCars())
    }, [])

    useEffect(() => {

        if(cars.length > 0){
            const highest = Math.max(...cars.map(c=>c.rentPerHour))
            setMaxPrice(highest)
            setPriceRange([0, highest])
        }

        applyFilters(cars, searchTerm, activeCategory, priceRange)
        
    }, [cars])

    function applyFilters(sourceCars, search, category, price){
        let temp = sourceCars

        if(category !== 'All'){
            temp = temp.filter(car => car.fuelType.toLowerCase() === category.toLowerCase())
        }

        if(search.trim() !== ''){
            temp = temp.filter(car =>
                car.name.toLowerCase().includes(search.toLowerCase()) ||
                car.fuelType.toLowerCase().includes(search.toLowerCase())
            )
        }

        temp = temp.filter(car => car.rentPerHour >= price[0] && car.rentPerHour <= price[1])

        setTotalcars(temp)
    }

    function handleSearch(e){
        const value = e.target.value
        setSearchTerm(value)
        applyFilters(cars, value, activeCategory, priceRange)
    }

    function handleCategoryClick(key){
        setActiveCategory(key)
        applyFilters(cars, searchTerm, key, priceRange)
    }

    function handlePriceChange(values){
        setPriceRange(values)
        applyFilters(cars, searchTerm, activeCategory, values)
    }


    function setFilter(values){

        var selectedFrom = moment(values[0] , 'MMM DD yyyy HH:mm')
        var selectedTo = moment(values[1] , 'MMM DD yyyy HH:mm')

        var temp=[]

        for(var car of cars){

              if(car.bookedTimeSlots.length == 0){
                  temp.push(car)
              }
              else{

                   for(var booking of car.bookedTimeSlots) {

                       if(selectedFrom.isBetween(booking.from , booking.to) ||
                       selectedTo.isBetween(booking.from , booking.to) || 
                       moment(booking.from).isBetween(selectedFrom , selectedTo) ||
                       moment(booking.to).isBetween(selectedFrom , selectedTo)
                       )
                       {

                       }
                       else{
                           temp.push(car)
                       }

                   }

              }

        }


        setTotalcars(temp)


    }

    return (
        <DefaultLayout>

             <div className="top-search-wrap">
                 <Input
                     size="large"
                     placeholder="Search cars by name or fuel type..."
                     prefix={<SearchOutlined style={{color:'#4f46e5'}} />}
                     value={searchTerm}
                     onChange={handleSearch}
                     className="top-search-input"
                 />
             </div>

             <div className="category-row">
                 {categories.map(cat => (
                     <div
                        key={cat.key}
                        className={`category-item ${activeCategory === cat.key ? 'active' : ''}`}
                        onClick={()=>handleCategoryClick(cat.key)}
                     >
                         <span className="category-icon">{cat.icon}</span>
                         <span className="category-label">{cat.label}</span>
                     </div>
                 ))}
             </div>

             <Row className='mt-3' justify='center'>
                 
                 <Col lg={20} sm={24} className='d-flex justify-content-left'>

                     <RangePicker showTime={{format: 'HH:mm'}} format='MMM DD yyyy HH:mm' onChange={setFilter}/>
                 
                 </Col>

             </Row>

             <Row className='mt-3' justify='center'>

                 <Col lg={20} sm={24}>
                     <div className="price-filter-wrap">
                         <span className="price-filter-label">Price range: ₹{priceRange[0]} - ₹{priceRange[1]} / hour</span>
                         <Slider
                             range
                             min={0}
                             max={maxPrice}
                             value={priceRange}
                             onChange={handlePriceChange}
                         />
                     </div>
                 </Col>

             </Row>

              {loading == true && (<Spinner/>)}

              {!loading && totalCars.length === 0 && (
                  <div className="empty-state">
                      <p>No cars found matching your filters. Try adjusting search or price range.</p>
                  </div>
              )}

              
              <Row justify='center' gutter={[20, 28]} className="mt-2">

                   {totalCars.map(car=>{
                       return <Col lg={5} sm={24} xs={24}>
                            <div className="car-card">
                               <div className="car-card-imgwrap">
                                   <img src={car.image} className="car-card-img"/>
                               </div>

                               <div className="car-card-body">
                                    <div className="car-card-name">{car.name}</div>
                                    <div className="car-card-price"><b>₹{car.rentPerHour}</b> / hour</div>
                                    <Link to={`/booking/${car._id}`} className="car-card-book">Book Now</Link>
                               </div>
                            </div>
                       </Col>
                   })}

              </Row>

        </DefaultLayout>
    )
}

export default Home
